export default __webpack_public_path__ + "media/zurb/img/events/wired/sacred-heart/sacred-heart-photos-ace5f5bc8317e30fa96759a48b334038.png";